import React, { RefObject } from 'react'
import browsercheck from '@ta-interaktiv/browsercheck'

export type Size = {
  width: number
  height: number
  isMobile: boolean
}

function getSize(el: any) {
  const bbox = el.getBoundingClientRect()
  return {
    width: bbox.width,
    height: bbox.height,
    isMobile: browsercheck.isMobile
  }
}

export function useSize(): [RefObject<HTMLDivElement>, Size] {
  const container = React.useRef(null)
  const [size, setSize] = React.useState<Size>({
    width: 0,
    height: 0,
    isMobile: true
  })
  const handleResize = React.useCallback(
    function handleResize() {
      if (container.current !== null) {
        setSize(getSize(container.current))
      }
    },
    [container]
  )
  React.useLayoutEffect(() => {
    handleResize()
    window.addEventListener('resize', handleResize)
    return function() {
      window.removeEventListener('resize', handleResize)
    }
  }, [container])

  return [container, size]
}

export default useSize
